import script from "./ToolForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolForm.vue?vue&type=script&setup=true&lang=js"

import "./ToolForm.vue?vue&type=style&index=0&id=0c04473c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c04473c"]])

export default __exports__